import { jsx } from "react/jsx-runtime";
import React from "react";
const LabileSitesLayer = ({ leftMargin, charWidth, positionsToMark = [] }) => {
  return /* @__PURE__ */ jsx("div", { className: "veLabileSites", children: positionsToMark?.map((pos, i) => {
    const x = leftMargin + (pos - 1.2) * charWidth + charWidth / 2;
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: "veAlignmentViewLabileSiteLine",
        style: {
          left: x
        }
      },
      i
    );
  }) });
};
export default LabileSitesLayer;
